import React from "react";

/**
 * AppStickyFooter — fixed footer at the bottom of mobile viewports.
 * Used for inline pages (NOT modals — modals use their own footer).
 * Renders MAX 2 actions side-by-side on mobile.
 */
export function AppStickyFooter({
    primaryAction,
    secondaryAction,
    children,
    className = "",
    testId,
}) {
    if (children) {
        return (
            <div
                data-testid={testId || "app-sticky-footer"}
                className={`sticky bottom-0 z-30 border-t border-md-border bg-md-surface/90 backdrop-blur-md px-4 py-3 pb-[max(env(safe-area-inset-bottom),0.75rem)] ${className}`}
            >
                {children}
            </div>
        );
    }
    return (
        <div
            data-testid={testId || "app-sticky-footer"}
            className={`sticky bottom-0 z-30 border-t border-md-border bg-md-surface/90 backdrop-blur-md px-4 py-3 pb-[max(env(safe-area-inset-bottom),0.75rem)] ${className}`}
        >
            <div className="flex gap-2">
                {secondaryAction && (
                    <button
                        type="button"
                        onClick={secondaryAction.onClick}
                        disabled={secondaryAction.disabled}
                        data-testid="app-sticky-footer-secondary"
                        className="inline-flex h-12 flex-1 items-center justify-center rounded-xl border border-md-border bg-transparent text-sm font-semibold text-md-text hover:bg-md-surface-2 disabled:opacity-50"
                    >
                        {secondaryAction.label}
                    </button>
                )}
                {primaryAction && (
                    <button
                        type="button"
                        onClick={primaryAction.onClick}
                        disabled={primaryAction.disabled}
                        data-testid="app-sticky-footer-primary"
                        className={
                            primaryAction.variant === "destructive"
                                ? "inline-flex h-12 flex-1 items-center justify-center rounded-xl bg-md-danger text-sm font-semibold text-white hover:opacity-90 disabled:opacity-50"
                                : "inline-flex h-12 flex-1 items-center justify-center rounded-xl bg-md-primary text-sm font-semibold text-md-primary-fg hover:opacity-90 disabled:opacity-50"
                        }
                    >
                        {primaryAction.label}
                    </button>
                )}
            </div>
        </div>
    );
}

export default AppStickyFooter;
